document.addEventListener('DOMContentLoaded', function () {
  initProductBlockHover(document);
});

document.addEventListener('shopify:section:load', function (event) {
  if (!event.target) return;
  initProductBlockHover(event.target);
});

function initProductBlockHover(root) {
  var scope = root || document;
  var wrappers = scope.querySelectorAll('.product-block__image-wrapper[data-secondary-src]');

  if (!wrappers.length) return;

  wrappers.forEach(function (wrapper) {
    var img = wrapper.querySelector('.product-block__image');
    if (!img) return;

    var primarySrc = wrapper.getAttribute('data-primary-src') || img.getAttribute('src');
    var secondarySrc = wrapper.getAttribute('data-secondary-src');
    if (!secondarySrc) return;

    function showSecondary() {
      img.src = secondarySrc;
    }

    function showPrimary() {
      img.src = primarySrc;
    }

    wrapper.addEventListener('mouseenter', showSecondary);
    wrapper.addEventListener('mouseleave', showPrimary);
    wrapper.addEventListener('focusin', showSecondary);
    wrapper.addEventListener('focusout', showPrimary);
  });
}

